import type { Milestone } from '@common/types';

import { CURRENT_USER_ID } from './org-users.seed';

export const MILESTONES_SEED: ReadonlyArray<Milestone> = [
  {
    id: 'ms-1',
    scope: 'organization',
    scopeId: 'sun-intl',
    dateIso: '2026-03-01',
    label: 'Group brand refresh',
    description: 'New guest-facing identity rolled out across every property and survey.',
    tone: 'brand',
    visibility: 'organisation',
    ownerId: null,
  },
  {
    id: 'ms-2',
    scope: 'organization',
    scopeId: 'sun-intl',
    dateIso: '2026-06-15',
    label: 'Post-stay survey v4',
    description: 'Question set shortened from 22 to 14 questions.',
    tone: 'info',
    visibility: 'organisation',
    ownerId: null,
  },
  {
    id: 'ms-3',
    scope: 'organization',
    scopeId: 'sun-intl',
    dateIso: '2026-07-01',
    label: 'Loyalty programme relaunch',
    description: 'Sun Rewards replaced MostValuedGuest across all regions.',
    tone: 'success',
    visibility: 'organisation',
    ownerId: null,
  },
  {
    id: 'ms-4',
    scope: 'account',
    scopeId: 'sun-001',
    dateIso: '2026-02-10',
    label: 'Lobby refurbishment complete',
    description: 'Six-week closure of the ground floor ended.',
    tone: 'success',
    visibility: 'organisation',
    ownerId: null,
  },
  {
    id: 'ms-5',
    scope: 'account',
    scopeId: 'sun-001',
    dateIso: '2026-05-20',
    label: 'New F&B operator',
    description: 'Restaurant handed to an external operator.',
    tone: 'warning',
    visibility: 'organisation',
    ownerId: null,
  },
  {
    id: 'ms-6',
    scope: 'account',
    scopeId: 'sun-001',
    dateIso: '2026-08-01',
    label: 'Air-conditioning outage',
    description: 'Chiller failure affected floors 4 to 9 for eleven days.',
    tone: 'danger',
    visibility: 'organisation',
    ownerId: null,
  },
  {
    id: 'ms-7',
    scope: 'account',
    scopeId: 'sun-002',
    dateIso: '2026-04-04',
    label: 'Spa reopened',
    description: 'Full refurbishment with two new treatment rooms.',
    tone: 'success',
    visibility: 'organisation',
    ownerId: null,
  },
  {
    id: 'ms-8',
    scope: 'user',
    scopeId: CURRENT_USER_ID,
    dateIso: '2026-08-12',
    label: 'Took over Table Bay reporting',
    description: 'Personal marker, not visible to the rest of the organisation.',
    tone: 'neutral',
    visibility: 'private',
    ownerId: CURRENT_USER_ID,
  },
];
